module.exports = __webpack_public_path__ + "img/uz.2627db26.svg";